export class SessionStorageService {
  constructor (key) {
    this.key = key
    this.storage = window.sessionStorage
  }

  get () {
    const value = this.getStorage().getItem(this.key)
    return this.decode(value)
  }

  getStorage () {
    return this.storage
  }

  set (value) {
    const encodedValue = this.encode(value)

    if (encodedValue === null) {
      this.remove()
      return
    }

    this.getStorage().setItem(this.key, encodedValue)
  }

  remove () {
    this.getStorage().removeItem(this.key)
  }

  decode (value) {
    if (value === null) {
      return null
    }
    return JSON.parse(value)
  }

  encode (value) {
    if (value === null) {
      return null
    }
    return JSON.stringify(value)
  }
}
